import { InjectionToken } from '@angular/core';
import { ISlideshowRepository } from '../../domain/repository/slideshow.respository';

export const SLIDESHOW_REPOSITORY = new InjectionToken<ISlideshowRepository>(
  'ISlideshowRepository',
);
